;(function($, window, document){
    window.FilteredContent = Me.view.extend({
        options: {
            childModulo: 0
        },

        initialize: function() {
            _.bindAll(this, 'addEvents', 'breakpointHandler', 'filterContents', 'lastChildHandler');

            this.addEvents();
        },
        addEvents: function() {
            Me.dispatch.subscribe('breakpointChanged', this.breakpointHandler);
            Me.dispatch.subscribe('filter.selected', this.filterContents);
        },
        breakpointHandler: function (e, params) {
            var view = this;

            var singleResult = this.$el.find('.single-result');
            singleResult.removeClass('last');

            if (params.breakpoint === '767-') {
                this.options.childModulo = 0;
            }
            else if (params.breakpoint === '768-1023') {
                this.options.childModulo = 2;
            }
            else {
                this.options.childModulo = 3;
            }

            this.lastChildHandler(this.options.childModulo);
        },
        filterContents: function (e, params) {
            var singleResult = this.$el.find('.single-result');

            if (params.filter === 'all') {
                singleResult.removeClass('hide').removeClass('last');
            }
            else {
                singleResult.addClass('hide').removeClass('last');
                this.$el.find('.single-result.' + params.filter).removeClass('hide');
            }

            this.lastChildHandler(this.options.childModulo);
        },
        lastChildHandler: function (modulo) {

            var $singleResult = this.$el.find('.single-result').not(".hide");

            $singleResult.each(function (index) {
                if ((index+ 1) % modulo === 0){
                    $(this).addClass('last');
                }
            });
        }
    });
}(jQuery, window, document));
